import React, { useContext, useEffect, useState } from "react";
import ReactDOM from "react";

//import Controls from "./components/controls";


import { BasicContext } from '../../context/BasicContext'
import Menu from "./Menu";

import PieChat from "../../components/chats/PieChat";
import Lottery from "../../components/cards/Lottery";
import IDA from "../../components/cards/IDA";
import MDRT from "../../components/cards/MDRT";
import CardBase from "../../components/cards/CardBase";
import Notice from "../../components/cards/Notice";



import PerformanceChat from "../../components/chats/PerformanceChat";
import YearBonusChat from "../../components/chats/YearBonusChat";
import GoldSkyChat from "../../components/chats/GoldSkyChat";


let sURL = new URL(window.location.href);
sURL.searchParams.get('pid');

const _d: Date = new Date()
const cy: number = _d.getFullYear() - 1911
const _a: number[] = []
for (let i: number = cy; i > cy - 10; i--) {
    _a.push(i)
}
export default () => {
    //const bc = useContext(BasicContext)
    //const ws = useContext(WebServiceContext)
    // layout is an array of objects, see the demo for more complete usage
    const [year] = useState<number[]>(_a)
    const [currentYear, setCurrentYear] = useState<number>(cy)
    const [collapseAll, setCollapseAll] = useState<boolean>(true)

    return (
        <>
            <div className="dashboard-header">
                <div className="btns">
                    <Menu />
                </div>
                {
                    <div className="right">
                        <button className="hibBtn main"
                            onClick={() => {
                                setCollapseAll(!collapseAll)
                            }}
                        >全部{collapseAll ? "收合" : "展開"}</button>
                        <select className="hibSelect" onChange={(event: React.ChangeEvent<HTMLSelectElement>) => {
                            setCurrentYear(parseInt(event.target.value))
                        }}>
                            {
                                year.map((year: number, index: number) =>
                                    <option key={"year_" + index}>{year}</option>)
                            }
                        </select>

                    </div>
                }
            </div>
            <div className="cardsContainer">
                <CardBase
                    collapseControl={collapseAll}
                    title="通知內容"
                    type="notice"
                    children={
                        <Notice />
                    }
                />
                <CardBase
                    collapseControl={collapseAll}
                    title="年度責任額"
                    type="pie"
                    children={
                        <PieChat
                            resType="年度責任額"
                            currentYear={currentYear}
                        />
                    }
                />
                <CardBase
                    collapseControl={collapseAll}
                    title="主管責任額"
                    type="pie"
                    children={
                        <PieChat
                            resType="主管責任額(歸屬後)"
                            currentYear={currentYear}
                        />
                    }
                />
                <CardBase
                    collapseControl={collapseAll}
                    title="摸彩券-菁英會業績"
                    children={
                        <Lottery 
                            currentYear={currentYear}
                        />
                    }
                />
                <CardBase
                    collapseControl={collapseAll}
                    title="績效獎金"
                    type="resBonus"
                    children={
                        <PerformanceChat
                            currentYear={currentYear}
                        />
                    }
                />
                <CardBase
                    collapseControl={collapseAll}
                    title="年終獎金"
                    type="yearBonus"
                    children={
                        <YearBonusChat
                            currentYear={currentYear}
                        />
                    }
                />
                <CardBase
                    collapseControl={collapseAll}
                    title="金勤 & 天勤"
                    type="goldSky"
                    children={
                        <GoldSkyChat
                            currentYear={currentYear}
                        />
                    }
                />
                <CardBase
                    collapseControl={collapseAll}
                    title="IDA"
                    type="IDA"
                    children={
                        <IDA
                            currentYear={currentYear}
                        />
                    }
                />
                <CardBase
                    collapseControl={collapseAll}
                    title="MDRT"
                    type="MDRT"
                    children={
                        <MDRT
                            currentYear={currentYear}
                        />
                    }
                />
            </div>
        </>
    )

};
